import PizZip from "pizzip";
import Docxtemplater from "docxtemplater";
import ImageModule from "docxtemplater-image-module-free";
import { base64ADatos } from "./siteSurveyExtractor";

const RUTA_MACHOTE = `${process.env.PUBLIC_URL || ""}/documentos/Machote_BOM_plantilla.docx`;

const RUTAS_LOGO_EMPRESA = {
  Netjer: `${process.env.PUBLIC_URL || ""}/img/NJ-Logotipo.png`,
  Rexten: `${process.env.PUBLIC_URL || ""}/img/rexten.png`,
};

const PIXEL_TRANSPARENTE_BASE64 =
  "iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNk+A8AAQUBAScY42YAAAAASUVORK5CYII=";

const cargarLogoEmpresa = async (empresa) => {
  const ruta = RUTAS_LOGO_EMPRESA[empresa] || RUTAS_LOGO_EMPRESA.Netjer;
  const respuesta = await fetch(ruta);
  if (!respuesta.ok) {
    throw new Error(`No se pudo cargar el logo de la empresa (${ruta}).`);
  }
  return new Uint8Array(await respuesta.arrayBuffer());
};

const TAMANO_MAXIMO_LOGO_PORTADA = [190, 95];
const TAMANO_MAXIMO_LOGO_ENCABEZADO = [90, 40];
const TAMANO_MAXIMO_LOGO_EMPRESA_PORTADA = [140, 50];

const TAMANOS_MAXIMOS_POR_TAG = {
  logoCliente: TAMANO_MAXIMO_LOGO_PORTADA,
  logoClienteEncabezado: TAMANO_MAXIMO_LOGO_ENCABEZADO,
  logoEmpresaPortada: TAMANO_MAXIMO_LOGO_EMPRESA_PORTADA,
};

const leerDimensionesPng = (bytes) => {
  const firma = [0x89, 0x50, 0x4e, 0x47, 0x0d, 0x0a, 0x1a, 0x0a];
  if (bytes.length < 24 || !firma.every((valor, i) => bytes[i] === valor)) return null;
  const vista = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
  return [vista.getUint32(16), vista.getUint32(20)];
};

const leerDimensionesJpeg = (bytes) => {
  const vista = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
  if (bytes.length < 4 || vista.getUint16(0) !== 0xffd8) return null;
  let posicion = 2;
  while (posicion + 9 < bytes.length) {
    if (bytes[posicion] !== 0xff) {
      posicion += 1;
      continue;
    }
    const marcador = bytes[posicion + 1];
    const esSOF = marcador >= 0xc0 && marcador <= 0xcf && marcador !== 0xc4 && marcador !== 0xc8 && marcador !== 0xcc;
    if (esSOF) {
      return [vista.getUint16(posicion + 7), vista.getUint16(posicion + 5)];
    }
    posicion += 2 + vista.getUint16(posicion + 2);
  }
  return null;
};

const obtenerDimensionesImagen = (bytes) => leerDimensionesPng(bytes) || leerDimensionesJpeg(bytes) || [140, 70];

const ajustarProporcional = ([anchoOriginal, altoOriginal], [anchoMaximo, altoMaximo]) => {
  if (anchoOriginal <= 2 && altoOriginal <= 2) return [1, 1];
  const escala = Math.min(anchoMaximo / anchoOriginal, altoMaximo / altoOriginal);
  return [Math.round(anchoOriginal * escala), Math.round(altoOriginal * escala)];
};

const crearModuloImagenes = () =>
  new ImageModule({
    centered: false,
    fileType: "docx",
    getImage: (tagValue) => tagValue,
    getSize: (imgBuffer, _tagValue, tagName) => {
      const tamanoMaximo = TAMANOS_MAXIMOS_POR_TAG[tagName] || TAMANO_MAXIMO_LOGO_PORTADA;
      return ajustarProporcional(obtenerDimensionesImagen(imgBuffer), tamanoMaximo);
    },
  });

export const generarDocumentoBOM = async ({ nombreProyecto, fechaCreacion, logoCliente, empresa, secciones }) => {
  const [respuesta, datosLogoEmpresa] = await Promise.all([
    fetch(RUTA_MACHOTE),
    cargarLogoEmpresa(empresa),
  ]);
  if (!respuesta.ok) {
    throw new Error("No se pudo cargar el machote de BOM (public/documentos/Machote_BOM_plantilla.docx).");
  }
  const arrayBuffer = await respuesta.arrayBuffer();
  const zip = new PizZip(arrayBuffer);

  const doc = new Docxtemplater(zip, {
    paragraphLoop: true,
    linebreaks: true,
    modules: [crearModuloImagenes()],
  });

  const datosLogoCliente = logoCliente
    ? base64ADatos(logoCliente.base64)
    : base64ADatos(PIXEL_TRANSPARENTE_BASE64);

  try {
    await doc.renderAsync({
      nombreProyecto,
      fechaCreacion,
      logoCliente: datosLogoCliente,
      logoClienteEncabezado: datosLogoEmpresa,
      logoEmpresaPortada: datosLogoEmpresa,
      ...secciones,
    });
  } catch (error) {
    const detalle = error.properties && error.properties.errors
      ? error.properties.errors.map((e) => e.message).join("; ")
      : error.message;
    throw new Error(`No se pudo generar el BOM a partir del machote: ${detalle}`);
  }

  return doc.toBlob();
};
